module.exports = __webpack_public_path__ + "static/media/Seks.919bf5f2.PNG";